"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isObject(value) {
    return ((value !== null) && (typeof value === 'object'));
}
exports.default = isObject;
//# sourceMappingURL=is-object.js.map


//////////////////
// WEBPACK FOOTER
// ./~/subscriptions-transport-ws/dist/utils/is-object.js
// module id = ./node_modules/subscriptions-transport-ws/dist/utils/is-object.js
// module chunks = 53 54